<section *ngIf="alerts.length" class="alerts-tasks">
  <button
    *ngIf="hasMultipleAlerts"
    type="button"
    class="alerts-toggle"
    data-test-id="alerts-toggle"
    [attr.aria-expanded]="isExpanded"
    aria-controls="alerts-tasks-list"
    (click)="toggleAlerts()"
  >
    <span class="alerts-toggle-inner">
      <span class="alerts-toggle-label">
        <mat-icon
          svgIcon="leaf-system-filled-info"
          aria-hidden="true"
        ></mat-icon>
        <ng-leaf-heading type="title-small" [brandColor]="true">
          You have {{ alerts.length }} alerts
        </ng-leaf-heading>
      </span>
      <cigna-icon
        [type]="isExpanded ? 'chevron-thin-up' : 'chevron-thin-down'"
        aria-hidden="true"
      ></cigna-icon>
    </span>
  </button>

  <div id="alerts-tasks-list" class="alerts-list">
    <ng-container *ngFor="let alert of visibleAlerts">
      <ng-leaf-alert
        *ngIf="alert"
        [attr.data-alert-id]="alert.alertId"
        [headerText]="
          getCopyKey(alert, 'heading') | translate : { tin: alert.tin }
        "
        [status]="getStatus(alert)"
        [emphasis]="getEmphasis(alert)"
        [notDismissible]="true"
        variant="banner"
      >
        <div>
          <span
            [innerHTML]="
              getCopyKey(alert, 'body') | translate : getCopyParams(alert)
            "
          ></span>
          <ng-container *ngIf="alert.alertType === 'DIRECTORY_UPDATE_REQUIRED'">
            <br />
            <a
              class="external-link-icon"
              href="https://www.evernorth.com/providers/behavioral/administrative-guidelines/provider-directory-changes"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{
                'shared.alertsTasks.DIRECTORY_UPDATE_REQUIRED.learnMore'
                  | translate
              }}
              <ng-leaf-icon-next
                category="system"
                weight="regular"
                name="external-link"
                size="16"
                ariaLabel=""
              ></ng-leaf-icon-next>
            </a>
          </ng-container>
        </div>

        <div class="cg-margin-top-md">
          <ng-leaf-button
            size="sm"
            variant="secondary"
            [neutral]="true"
            [inverse]="getEmphasis(alert) === 'strong'"
            [text]="getCopyKey(alert, 'ctaText') | translate"
            (click)="onStartReview(alert)"
          >
          </ng-leaf-button>
        </div>
      </ng-leaf-alert>
    </ng-container>
  </div>
</section>
